/*
 * Copyright © 2024 Himitsu Lab Limited. All Rights Reserved.
 */

import React, { useEffect } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import Footer from '../../Containers/Footer'
import { useCurrentTimezoneHook } from '../../Hooks/CurrentTimezoneHook'
import useWebSocket from '../../Hooks/SocketHook'
import { getToken } from '../../Services/tokenReducer'
import { useGetCurrentUserDetailsQuery } from '../../Services/userApi'
import { getCurrentUser } from '../../Services/userReducer'
import { useAppSelector } from '../../Store/hooks'
import ScrollToTop from '../ScrollToTop'
import Header from '../../Containers/Header'

function IntroScreenMenu() {
  const navigate = useNavigate()
  const location = useLocation()

  const { timeZone } = Intl.DateTimeFormat().resolvedOptions()
  useCurrentTimezoneHook(timeZone)
  useGetCurrentUserDetailsQuery()

  const token = useAppSelector(getToken)
  const currentUser = useAppSelector(getCurrentUser)

  useWebSocket()

  useEffect(() => {
    if (!token || !currentUser) {
      navigate('/')
    }
  }, [token, currentUser, navigate])

  if (!currentUser) {
    return null
  }

  return (
    <div className="h-screen flex flex-1 flex-col">
      <div className="flex flex-col justify-between">
        <div className="w-full px-6 z-30">
          <Header />
        </div>
        <div className="min-h-[85vh] overflow-hidden">
          <ScrollToTop />
          <Outlet />
        </div>
        {/* {!location.pathname.startsWith('/s/ameeting/') && <Footer />} */}
      </div>
    </div>
  )
}

export default React.memo(IntroScreenMenu)


